import React, {useState, useEffect} from "react";
import { CloudinaryContext, Image } from "cloudinary-react";
import { fetchPhotos, openUploadWidget } from "../../CloudinaryService";

function ImageUpload({brand, path, inputField}) {
    const [images, setImages] = useState([]);

    const beginUpload = tag => {
      const uploadOptions = {
        cloudName: "motortrak",
        uploadPreset: "cmspreset",
        folder: `cms/${brand}/hero-image`,
        tags: [tag, `${brand} hero image`]
      };
    
      openUploadWidget(uploadOptions, (error, photos) => {
        if (!error) {
          if (photos.event === 'success') {
            setImages(images,photos.info.public_id)
            document.getElementById(`${inputField}`).innerHTML = `Cloudinary Image Uploaded:  https://res.cloudinary.com/motortrak/image/upload/${photos.info.public_id}`;

            const input = document.getElementsByName(`${inputField}`)[0]; 
            const lastValue = input.value;
            input.value = `https://res.cloudinary.com/motortrak/image/upload/${photos.info.public_id}`;
            const event = new Event('input', { bubbles: true });
            event.simulated = true;
            const tracker = input._valueTracker;
            if (tracker) {
              tracker.setValue(lastValue);
            }
            input.dispatchEvent(event);            
          }
        } 
        else {
          console.log(error);         
        }
      })
    }

    useEffect( () => {
      fetchPhotos("image", setImages);
    }, [])
    
    return (        
        <CloudinaryContext cloudName="motortrak" uploadPreset= "cmspreset">
          <button onClick={() => beginUpload("image")}>Upload Image</button>
          <section id={inputField} style={{fontSize:'1rem', fontStyle:'italic', color:'#2793ec', fontWeight:'bold'}}/>
        </CloudinaryContext>
      );
};

export default ImageUpload;